import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { firestorePlugin } from "vuefire";
import { db } from "@/db";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import ImageUploader from "vue-image-upload-resize";
import VueSignaturePad from "vue-signature-pad";
// import { VueReCaptcha } from "vue-recaptcha-v3";
import firebase from "firebase";
import "./registerServiceWorker";

Vue.config.productionTip = false;
Vue.use(ImageUploader);
Vue.use(VueSignaturePad);
Vue.use(firestorePlugin);
Vue.use(VueSweetalert2);
// Vue.use(VueReCaptcha, {
//   siteKey: "6LfSlgAVAAAAAIpFd-YuVi2U1mKa4e3lNStSgtXn",
//   loaderOptions: {
//     useRecaptchaNet: true,
//     autoHideBadge: true
//   }
// });

let app;
// eslint-disable-next-line no-unused-vars
firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    // eslint-disable-next-line no-unused-vars
    const app = new Vue({
      router,
      vuetify,
      // setup the reactive todos property
      data: () => ({
        repairs: []
      }),

      firestore: {
        repairs: db.collection("repairs")
      },
      render: h => h(App)
    }).$mount("#app");
  }
});

window.vue = app;
